
import styles from './heading.module.css';

export function Heading({ children, color }) {
  return <h2 className={`${styles.heading} ${styles[color]}`}>{children}</h2>;
}
